import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GqlEcologicalFunctionTypeGetAutocompleteOptionsParams } from "~/__generated__";

import { EcologicalFunctionSelect_GetAutocompleteOptionsDocument } from "../queries.generated";

export default function useEcologicalFunctionSelect_GetAutocompleteOptions(
    params: GqlEcologicalFunctionTypeGetAutocompleteOptionsParams,
) {
    const { data, previousData, loading } = useQuery(EcologicalFunctionSelect_GetAutocompleteOptionsDocument, {
        variables: { params },
    });

    const options = useMemo(() => data?.ecologicalFunctionTypeGetAutocompleteOptions.data ?? [], [data]);
    const selectedOptions = useMemo(
        () => (data ?? previousData)?.ecologicalFunctionTypeGetAutocompleteOptions.selectedData ?? [],
        [data, previousData],
    );

    return { options, selectedOptions, loading };
}
